import { getUid } from "../../../lib/uidUtils";
import { FileUploaderFileValidationResult } from "../FileUploaderFileValidationResult";
export var FileUploaderFileStatus;

(function (FileUploaderFileStatus) {
  FileUploaderFileStatus["Attached"] = "Attached";
  FileUploaderFileStatus["Loading"] = "Loading";
  FileUploaderFileStatus["Uploaded"] = "Uploaded";
  FileUploaderFileStatus["Error"] = "Error";
})(FileUploaderFileStatus || (FileUploaderFileStatus = {}));

export var getAttachedFile = function getAttachedFile(file) {
  return {
    id: getUid(),
    originalFile: file,
    status: FileUploaderFileStatus.Attached,
    validationResult: FileUploaderFileValidationResult.ok()
  };
};